import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { OmGlyph } from "@/components/VedicOrnaments";

const Nav = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const linkClass = ({ isActive }) =>
    `text-[11px] tracking-[0.3em] uppercase transition-colors ${
      isActive ? "text-terracotta" : "text-ink hover:text-terracotta"
    }`;

  return (
    <header
      data-testid="site-nav"
      className="w-full border-b border-[var(--hairline)] bg-cream/80 backdrop-blur-sm sticky top-0 z-40"
    >
      <div className="max-w-[1500px] mx-auto flex items-center justify-between px-6 md:px-14 py-6">
        <Link to="/" className="flex items-baseline gap-3" data-testid="logo-link">
          <OmGlyph size={20} />
          <span className="font-display text-2xl text-terracotta leading-none italic" style={{ fontWeight: 500 }}>
            Bhrigu
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-12">
          <NavLink to="/features" className={linkClass} data-testid="nav-features">Tradition</NavLink>
          <NavLink to="/pricing" className={linkClass} data-testid="nav-pricing">Pricing</NavLink>
          <NavLink to="/about" className={linkClass} data-testid="nav-about">About</NavLink>
          <NavLink to="/faq" className={linkClass} data-testid="nav-faq">FAQ</NavLink>
          <NavLink to="/contact" className={linkClass} data-testid="nav-contact">Contact</NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-5">
          {user ? (
            <>
              <Link to="/app" className="text-[11px] tracking-[0.3em] uppercase text-ink hover:text-terracotta" data-testid="nav-dashboard">
                Dashboard
              </Link>
              <button onClick={() => { logout(); navigate("/"); }} className="btn-ghost" data-testid="nav-logout">
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-[11px] tracking-[0.3em] uppercase text-ink hover:text-terracotta" data-testid="nav-login">
                Sign in
              </Link>
              <Link to="/signup" className="btn-primary" data-testid="nav-signup">
                Cast Kundali
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden text-ink" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[var(--hairline)] bg-cream-soft px-6 py-6 flex flex-col gap-4" data-testid="nav-mobile-menu">
          <NavLink to="/features" className={linkClass} onClick={() => setOpen(false)}>Tradition</NavLink>
          <NavLink to="/pricing" className={linkClass} onClick={() => setOpen(false)}>Pricing</NavLink>
          <NavLink to="/about" className={linkClass} onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/faq" className={linkClass} onClick={() => setOpen(false)}>FAQ</NavLink>
          <NavLink to="/contact" className={linkClass} onClick={() => setOpen(false)}>Contact</NavLink>
          {user ? (
            <Link to="/app" className="btn-primary" onClick={() => setOpen(false)}>Dashboard</Link>
          ) : (
            <>
              <Link to="/login" className="btn-ghost" onClick={() => setOpen(false)}>Sign in</Link>
              <Link to="/signup" className="btn-primary" onClick={() => setOpen(false)}>Cast Kundali</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Nav;
